import React, { useEffect, useState } from "react";
import { Switch } from 'antd';
import DatePicker from "react-datepicker";
import 'bootstrap/dist/css/bootstrap.min.css';
import "react-datepicker/dist/react-datepicker.css";
import pt from "date-fns/locale/pt-BR";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Search from "@material-ui/icons/Search";
import Icon from "@material-ui/core/Icon";
import Pagination from '@material-ui/lab/Pagination';
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import styles2 from "assets/jss/material-dashboard-react/components/headerLinksStyle.js";
import Button from "components/CustomButtons/Button.js";
import CardIcon from "components/Card/CardIcon.js";
import CardFooter from "components/Card/CardFooter.js";
import TableSell from "components/TableSell/TableSell"
import api from "assets/services/api.js";
import useAuth from "hooks/useAuth";
import ModalAddSell from "components/ModalAddSell/ModalAddSell";
const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  },
  colorCard: {
    color: "#999"
  },
  floatRight: {
    float: "right"
  },
  maxwidht: {
    maxWidth: "107%"
  },
  toogleclass: {
    marginTop: "14px",
    marginBottom: "14px",
    width: "65%",
  },
  backGreen: {
    backgroundColor: "#4caf50"
  },
  backRed: {
    backgroundColor: "rgb(244 67 54 / 1)"
  },
  zindex: {
    zIndex: "0 !important"
  },
  marginDate: {
    marginTop: "12px",
    marginBottom: "12px"
  }
};


const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(styles2);


export default function Sell() {

  Date.prototype.withoutTime = function () {
    var d = new Date(this);
    d.setHours(0, 0, 0, 0);
    return d;
  };
  const { storageId, garlicType, storageUserType } = useAuth();
  const classes = useStyles();
  const classes2 = useStyles2();
  // data bd
  const [sells, setSells] = useState([]);
  // params
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [search, setSearch] = useState("");
  const [toogle, setToggle] = useState(false);
  const [toogleCancel, setToggleCancel] = useState(false);
  const [toogle2, setToggle2] = useState(false);
  // pagination
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  //modals
  const [modalShow, setModalShow] = useState(false);
  const [importModal, setImportModal] = useState(false);

  useEffect(() => {
    loadSell();
  }, []);

  useEffect(() => {
    loadSell();
  }, [page, startDate, endDate, toogle, toogle2, toogleCancel, garlicType]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      loadSell();
    }, 900);

    return () => clearTimeout(delayDebounceFn)
  }, [search]);

  const toogler = () => {
    toogle ? setToggle(false) : setToggle(true);
  }
  const toogler2 = () => {
    toogle2 ? setToggle2(false) : setToggle2(true);
  }
  const tooglerCancel = () => {
    toogleCancel ? setToggleCancel(false) : setToggleCancel(true);
  }
  const handleChange = (event, value) => {
    setPage(value);
  };

  const alterModal = () => {
    setImportModal(true);
  }

  const callModalAddSell = () => {
    if (!modalShow) {
      alterModal();
    };
    setModalShow(true);
  }

  async function loadSell() {
    const data = await api.get(`/sell/view/${storageId}?page=${page}&type=${storageUserType}&date_init=${startDate}&date_end=${endDate}&control=${toogle}&search=${search}&remove=${toogle2}&cancel=${toogleCancel}&noFiscal=false&garlic=${garlicType}`);
    setSells(data.data.sells);
    setTotalPages(data.data.totalPages);

  };

  return (
    <GridContainer>
      <GridItem xs={12} sm={6} md={2}>
        <Card>
          <div className={classes.zindex}>
            <CardHeader className="d-flex justify-content-center zindex" color="warning" stats icon>
              <CardIcon color="success">
                <Icon>content_copy</Icon>
              </CardIcon>
            </CardHeader>
          </div>
          <CardBody className="d-flex justify-content-center">
            <p className={classes.colorCard}>Adicionar venda</p>
          </CardBody>
          <CardFooter className="d-flex justify-content-center" stats>
            <Button color="success" className={classes.margintp + " " + classes.maxwidht} onClick={() => callModalAddSell()}>
              Adicionar venda
            </Button>
          </CardFooter>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={6} md={2}>
        <Card>
          <div className={classes.zindex}>
            <CardHeader className="d-flex justify-content-center zindex {classes.zindex}" color="warning" stats icon>
              <CardIcon color="warning">
                <Icon>today</Icon>
              </CardIcon>
            </CardHeader>
          </div>
          <CardBody className="d-flex justify-content-center">
            <p className={classes.colorCard}><b>Filtro</b> de data primária</p>
          </CardBody>
          <CardFooter className="d-flex justify-content-center" stats>
            <DatePicker className={classes.marginDate}
              selected={startDate}
              onChange={date => setStartDate(date.withoutTime())}
              dateFormat="dd/MM/yyyy"
              placeholderText="Digite ou clique aqui"
              locale={pt}
              disabledKeyboardNavigation />
          </CardFooter>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={6} md={2}>
        <Card>
          <div className={classes.zindex}>
            <CardHeader className="d-flex justify-content-center" color="warning" stats icon>
              <CardIcon color="warning">
                <Icon>event</Icon>
              </CardIcon>
            </CardHeader>
          </div>
          <CardBody className="d-flex justify-content-center">
            <p className={classes.colorCard}><b>Filtro</b> de data final</p>
          </CardBody>
          <CardFooter className="d-flex justify-content-center" stats>
            <DatePicker className={classes.marginDate}
              selected={endDate}
              onChange={date => setEndDate(date.withoutTime())}
              dateFormat="dd/MM/yyyy"
              placeholderText="Digite ou clique aqui"
              locale={pt}
              disabledKeyboardNavigation />
          </CardFooter>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={6} md={2}>
        <Card>
          <div className={classes.zindex}>
            <CardHeader className="d-flex justify-content-center" color="warning" stats icon>
              <CardIcon color="info">
                <Icon>analytics</Icon>
              </CardIcon>
            </CardHeader>
          </div>
          <CardBody className="d-flex justify-content-center">
            <p className={classes.colorCard}>Vendas entregues</p>
          </CardBody>
          <CardFooter className="d-flex justify-content-center" stats>
            <Switch className={classes.toogleclass} onClick={toogler} />
          </CardFooter>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={6} md={2}>
        <Card>
          <div className={classes.zindex}>
            <CardHeader className="d-flex justify-content-center" color="warning" stats icon>
              <CardIcon color="primary">
                <Icon>analytics</Icon>
              </CardIcon>
            </CardHeader>
          </div>
          <CardBody className="d-flex justify-content-center">
            <p className={classes.colorCard}>Vendas retiradass</p>
          </CardBody>
          <CardFooter className="d-flex justify-content-center" stats>
            <Switch className={classes.toogleclass} onClick={toogler2} />
          </CardFooter>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={6} md={2}>
        <Card>
          <div className={classes.zindex}>
            <CardHeader className="d-flex justify-content-center" color="warning" stats icon>
              <CardIcon color="danger">
                <Icon>analytics</Icon>
              </CardIcon>
            </CardHeader>
          </div>
          <CardBody className="d-flex justify-content-center">
            <p className={classes.colorCard}>Vendas canceladas</p>
          </CardBody>
          <CardFooter className="d-flex justify-content-center" stats>
            <Switch className={classes.toogleclass} onClick={tooglerCancel} />
          </CardFooter>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={12} md={12}>
        <div className={classes2.searchWrapper}>
          <CustomInput
            formControlProps={{
              className: classes2.margin + " " + classes2.search
            }}
            inputProps={{
              placeholder: "Busca por nota físcal, razão social ou nome fantasia",
              inputProps: {
                "aria-label": "Search",
                type: "text",
                value: search,
                onChange: event => setSearch(event.target.value)
              }
            }}
          />
          <Button color="white" aria-label="edit" justIcon round>
            <Search />
          </Button>
        </div>
      </GridItem>
      {sells.map(sell => (
        <TableSell key={String("Sell_" + sell[0].nf)} sell={sell} loadSell={loadSell} toogleCancel={toogleCancel} />
      ))}
      <Pagination count={totalPages} page={page} onChange={handleChange} />
      {modalShow && importModal && (
        <ModalAddSell key={String("add_" + storageId)} show={modalShow} loadSell={loadSell} onHide={() => setModalShow(false)} />
      )}
    </GridContainer>
  );

}
